import { ErrorPage } from '@backstage/core-components';
import { defaultTypography } from '@backstage/theme';
import {
  createTheme,
  makeStyles,
  ThemeProvider,
  useTheme,
} from '@material-ui/core/styles';
import { useMemo } from 'react';
import './errorPage.css';

const useStyles = makeStyles(theme => ({
  root: {
    flex: '1 1 0',
    minWidth: 0,
    minHeight: '100dvh',
    boxSizing: 'border-box',
    padding: theme.spacing(8, 4),
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.default,
  },
}));

export const CustomNotFoundPage = () => {
  const styles = useStyles();
  const currentTheme = useTheme();
  const notFoundTheme = useMemo(
    () =>
      createTheme({
        ...currentTheme,
        typography: defaultTypography,
      }),
    [currentTheme],
  );

  return (
    <ThemeProvider theme={notFoundTheme}>
      <div className={styles.root}>
        <ErrorPage
          status="404"
          statusMessage="NotFoundError: Page not found."
        />
      </div>
    </ThemeProvider>
  );
};
